// @ts-strict-ignore
import { PropertyVO } from '@project/components/article/model/vo/property.vo';
import { IOperation } from '@shared/undo/operation/i-operation';
import { BasePropertyOperation } from './base-property-operation';
import { ArticleVO } from '@article/model/vo/article.vo';
import { ProjectModel } from '@project/model/project.model';
import { AdminService } from '../services/admin.service';
import { ConnectionUtils } from '@3d-scene/model3d/util/connection-utils';

export class ChangeConnectionPropertyOperation extends BasePropertyOperation implements IOperation {
  constructor(
    originalProperty: PropertyVO,
    private _newProperty: PropertyVO,
    private _connectionName: string,
    private _article: ArticleVO,
    private _newPropertyType: string,
    originalPropertyType: string,
    projectModel: ProjectModel,
    connectionUtils: ConnectionUtils,
    adminService: AdminService,
  ) {
    super(originalProperty, originalPropertyType, projectModel, connectionUtils, adminService);
  }

  public getQualifiedClassName(): string {
    return 'ChangeConnectionPropertyOperation';
  }

  public getOperationDescription(): string {
    return 'changedConnectionPropertyOperation.description';
  }

  public async performRedo(): Promise<void> {
    this.redoConnectionPropertyChanges(this._newProperty, this._newPropertyType, this._connectionName, this._article);
  }

  public async performUndo(): Promise<void> {
    this.undoConnectionPropertyChanges(this._newProperty, this._newPropertyType, this._connectionName, this._article);
  }
}
